import { render } from "./CreateRuleModal.vue?vue&type=template&id=1d164451&scoped=true&ts=true"
import script from "./CreateRuleModal.vue?vue&type=script&lang=ts"
export * from "./CreateRuleModal.vue?vue&type=script&lang=ts"

import "./CreateRuleModal.vue?vue&type=style&index=0&id=1d164451&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d164451"]])

export default __exports__